import { Component } from "@angular/core";

@Component({
    selector: "loggedout",
    templateUrl: "./loggedout.component.html",
})
export class LoggedOutComponent {
    message: string;
    loggingOut: boolean;

    constructor() {}
}
